import React, { useState, useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import camelCaseRecursive from 'camelcase-keys-recursive';
import { ComponentDataTable } from '../../index';
import { indexEmployeeSurveyRequest } from '../../../requests/employeeSurveys';
import getColumns from './TalentSurveyColumns';

const TalentSurveyDataTable = ({ employeeId }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [employeeSurveys, setEmployeeSurveys] = useState([]);
  const [amount, setAmount] = useState(0);
  const [loading, setLoading] = useState(false);

  const handleAction = useCallback(
    (item, action) => {
      const isAnonymous = item.isAnonymous || item.survey?.isAnonymous;
      if (action === 'view' && !isAnonymous) {
        history.push(`/surveys/employee_surveys/${item.id}`);
      }
    },
    [history]
  );

  const columns = useMemo(() => getColumns(handleAction), [handleAction]);

  const handleIndexRequest = params => {
    setLoading(true);
    const requestParams = {
      ...params,
      employee_id: employeeId
    };

    indexEmployeeSurveyRequest({
      dispatch,
      params: requestParams,
      successCallback: res => {
        const responseData = camelCaseRecursive(res.data);
        const { data, metadata } = responseData;

        setEmployeeSurveys(data || []);
        setAmount(metadata?.amount || 0);
      },
      callback: () => setLoading(false)
    });
  };

  return (
    <div className="mx-3 mt-3">
      <div className="data-table-yellow">
        <ComponentDataTable
          resourceRequest={handleIndexRequest}
          onRequest={loading}
          columns={columns}
          data={employeeSurveys}
          totalRows={amount}
          noDataComponentText="No hay encuestas registradas para este colaborador."
          withSearch
        />
      </div>
    </div>
  );
};

export default TalentSurveyDataTable;
